import type { PropsWithChildren } from 'react';
import { createContext, useContext, useMemo } from 'react';

interface Props {
  hasDuplicationErrors?: boolean;
  isDisabled?: boolean;
}

const GlobalSpecialsModalContext = createContext<Props>({});
GlobalSpecialsModalContext.displayName = 'GlobalSpecialsModal';

export const useGlobalSpecialsModal = () =>
  useContext(GlobalSpecialsModalContext);

export const GlobalSpecialsModalProvider = ({
  children,
  hasDuplicationErrors,
  isDisabled,
}: PropsWithChildren<Props>) => {
  const contextValue = useMemo(
    () => ({
      hasDuplicationErrors,
      isDisabled,
    }),
    [hasDuplicationErrors, isDisabled]
  );

  return (
    <GlobalSpecialsModalContext.Provider value={contextValue}>
      {children}
    </GlobalSpecialsModalContext.Provider>
  );
};
